import React from 'react';
import { Progress, Typography, Row, Col } from 'antd';
import { useDarkMode } from 'src/context/DarkModeContext';
const { Text } = Typography;

interface QuizProgressBarProps {
    questionNumber: number;
    totalQuestionNumber: number;
}

const QuizProgressBar: React.FC<QuizProgressBarProps> = ({ questionNumber, totalQuestionNumber }) => {
    const { isDarkMode } = useDarkMode();
    const progress = totalQuestionNumber > 0 ? (questionNumber / totalQuestionNumber) * 100 : 0;

    return (
        <Row
            style={{
                padding: '0 16px',
                alignItems: 'center',
                display: 'flex',
            }}
        >
            {/* Progress Bar */}
            <Col span={24}>
                <Text style={{ color: isDarkMode ? '#7bbdfb' : '#6b99f8' }} strong>
                    Question {questionNumber} / {totalQuestionNumber}
                </Text>
                <Progress
                    strokeLinecap="round"
                    trailColor="#b2b2b2"
                    percent={progress}
                    status="active"
                    showInfo={false}
                    style={{ borderRadius: '50px' }}
                />
            </Col>
        </Row>
    );
};

export default QuizProgressBar;
